import type { DirectMediaUploadResponse, FinalizeMediaByFingerprintsResponse } from '@/types/mediaApiTypes';

/** Uuid of the single media row a one-file upload returns; throws when the response has none. */
export function firstMediaUuid(res: DirectMediaUploadResponse | FinalizeMediaByFingerprintsResponse): string {
  const row = res.data[0];
  if (!row?.uuid) {
    throw new Error('Upload response did not include media uuid');
  }
  return row.uuid;
}
